module.exports = __webpack_public_path__ + "img/noCrimeCertImg.826a0ec2.png";